import { useMutation } from '@tanstack/react-query'
import { useCompanyInfo } from '../company'
import { updateBonusLimit } from 'api/payment'

interface UseUpdateBonusLimitMutation {
  onSuccess?: () => void
  onError?: (err: Error) => void
}

export function useUpdateBonusLimitMutation(
  options?: UseUpdateBonusLimitMutation
) {
  const { data: company } = useCompanyInfo()

  return useMutation({
    mutationFn: async (limit: number) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }
      return updateBonusLimit(company.id, limit)
    },
    ...options,
  })
}
